import { render } from "./InventoryReview.vue?vue&type=template&id=19a506b9&scoped=true&ts=true"
import script from "./InventoryReview.vue?vue&type=script&lang=ts"
export * from "./InventoryReview.vue?vue&type=script&lang=ts"

import "./InventoryReview.vue?vue&type=style&index=0&id=19a506b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a506b9"]])

export default __exports__